import React from 'react'
import './contact.css'
import {RiTelegramLine} from 'react-icons/ri'
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { useState } from 'react';


export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {

    e.preventDefault();
  
    emailjs.sendForm('service_4ua9ny9', 'template_qjembeh', form.current, 'xAsjnqf__mdyW2oEr')
      .then((result) => {
          // console.log(result.text);
      }, (error) => {
          // console.log(error.text);
      });
      e.target.reset();
  };
  return (
    <section id = "contact">
      <h5>Get in Touch</h5>
      <h2>
        Contact Me
      </h2>
      <div className="container contact_container">

        <div className="contact_options">
           <article className="contact_option">
              < MdOutlineEmail className="contact_icon" />
                <h4>Email</h4>
                <a href="mailto:meharithegreat@gmail.com">Send a Message</a>
            </article>
            <article className="contact_option">
              <RiTelegramLine className="contact_icon" />
                <h4>telegram</h4>
                <a href="https://t.me/https://t.me/me_ha_ri" target="_blank">Send a Message</a>
            </article>
            <article className="contact_option">
              < BsWhatsapp className="contact_icon" />
                <h4>whatsup</h4>
                <a href="https://api.whatsapp.com/send?phone+251973997144" target="_blank">Send a Message</a>
            </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
            <input type= "text" name='name' placeholder='Your Full Name' required />  
            <input type= "text" name='conatact' placeholder='Email/telegram/phone' required />    
            <textarea name="message" rows="7" placeholder="Your Message Please"/>  
            <button type="submit" className="btn btn-primary">Send Message</button>
        </form>
      </div>
    </section >
  )
}
